module.exports = __webpack_public_path__ + "img/lanc1.ba40c772.jpg";